import styled from '@emotion/styled';
import { Image } from 'antd';
import { FC, useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BigImgCard } from '../../common/component/BigImgCard';
import { Bread } from '../../common/component/Bread';
import { ImageFill } from '../../common/component/ImageFill';
import { ImgCard } from '../../common/component/ImgCard';
import { RightArrows } from '../../common/component/RightArrows';
import { IndustryEntity } from '../../module/industry/entity/industry.entity';
import { getIndustry } from '../../module/industry/service/industry.service';
import { ProductImgCard } from '../../module/product/component/ProductImgCard';

export const IndustryDetail: FC = () => {
	const [info, setInfo] = useState<IndustryEntity>({});

	const { id } = useParams();
	const navigate = useNavigate();

	const init = useCallback(async () => {
		const { data } = await getIndustry(Number(id));
		setInfo(data);
	}, [id]);

	useEffect(() => {
		window.scrollTo(0, 0);
		init();
	}, [init]);

	const breadArr = [
		{
			title: '行业相关',
			link: '/industries',
		},
		{
			title: info.title,
		},
	];

	return (
		<Container>
			<ImageFill src={info.image ?? ''} width={1600} height={500} areaHeight={296} />
			<div className='content'>
				<div className='page-title'>
					<h1>{info.subTitle}</h1>
				</div>
				<Bread value={breadArr} />
				<div className='description'>
					<div className='left'>
						<div className='inner-description' dangerouslySetInnerHTML={{ __html: info.description ?? '' }} />
						<div className='customer-quote'>
							<div className='left'>
								<div className='comments'>{info.userComments}</div>
								<div>{info.userInfo}</div>
							</div>
							<div className='svg'>
								<Image src='https://optibelt.oss-cn-shanghai.aliyuncs.com/img/testimonial-spitze.svg' preview={false} />
							</div>
						</div>
					</div>
					<div className='right'>
						<div className='image'>
							<Image src={info.userImage} preview={false} />
						</div>
					</div>
				</div>
			</div>
			<div className='exterinor-content'>
				<div className='content'>
					{info.applicationTitle && (
						<div className='application'>
							{info.applicationImage && <Image src={info.applicationImage} preview={false} />}
							<h2>{info.applicationTitle}</h2>
						</div>
					)}
					{info.applicationArr && (
						<div className='applications'>
							{info.applicationArr.map((item, index) => {
								return (
									<>
										{item.type == 2 && (
											<div className='item col-lg-6 col-md-12 col-xs-12' key={index}>
												<BigImgCard
													img={item.image ?? ''}
													title={item.title}
													subTitle={item.subTitle}
													description={item.description}
													linkTitle={item.url ? '查看详情' : ''}
													url={item.url ?? ''}
												/>
											</div>
										)}
										{item.type == 1 && (
											<div className='item col-lg-3 col-md-4 col-xs-12' key={index}>
												<ImgCard
													img={item.image ?? ''}
													title={item.title}
													subTitle={item.subTitle}
													description={item.description}
													linkTitle={item.url ? '查看详情' : ''}
													url={item.url ?? ''}
												/>
											</div>
										)}
									</>
								);
							})}
						</div>
					)}

					{info.tagTitle && <h2>{info.tagTitle}</h2>}
					{info.tagContent && (
						<div className='tag-list'>
							{info.tagContent.split(',').map((item, index) => (
								<div className='tag col-lg-3 col-md-4 col-xs-12' key={index}>
									<div>{item}</div>
								</div>
							))}
						</div>
					)}

					{info.referenceIds && <h2>{info.title}的参考文献</h2>}
					{info.referenceIds && (
						<div className='reference-list'>
							{info.referenceArr &&
								info.referenceArr.map((item, index) => (
									<a className='item col-lg-3 col-md-4 col-xs-12' key={index} href={item.url ?? ''} target='_blank' rel='noreferrer'>
										<Image src={item.image} preview={false} />
									</a>
								))}
						</div>
					)}

					{info.productTitle && (
						<div>
							<h2>{info.productTitle}</h2>
						</div>
					)}
					{info.productArr && info.productArr?.length > 0 && (
						<div className='products'>
							{info.productArr.map((item, index) => {
								return (
									<div key={index} className='item col-lg-4 col-md-3 col-xs-12'>
										<ProductImgCard src={item.image} url={`/product/${item.id}`} />
									</div>
								);
							})}
						</div>
					)}
					{info.productTitleMulti && (
						<div>
							<h2>{info.productTitle}</h2>
						</div>
					)}
					{info.productMultiArr && info.productMultiArr?.length > 0 && (
						<div className='products'>
							{info.productMultiArr.map((item, index) => {
								return (
									<div key={index} className='item col-lg-4 col-md-3 col-xs-12'>
										<ProductImgCard src={item.image} url={`/product/${item.id}`} />
									</div>
								);
							})}
						</div>
					)}

					{info.showSuccessStory == 1 && (
						<div className='successStories'>
							<Image src={info.successStoryImage} preview={false} />
							<div className='title'>成功案例</div>
							<div className='list'>
								{info.successStoryArr &&
									info.successStoryArr.map((item, index) => {
										const length = info.successStoryArr?.length ?? 1;
										const lgLength = Math.ceil(9 / length);
										return (
											<div className={`item col-lg-${lgLength > 6 ? 6 : lgLength} col-md-5 col-xs-12`} key={index}>
												<Image src={item.image} preview={false} width='100%' />
												<h2>{item.title}</h2>
												<div
													dangerouslySetInnerHTML={{
														__html: item.description ?? '',
													}}
												/>
												{item.productArr &&
													item.productArr.map((item1, index1) => {
														return (
															<div className='productLink' key={index1} onClick={() => navigate(`/product/${item1.id}`)}>
																<div>
																	<span>产品：</span>
																	<b>{item1.title}</b>
																</div>
																<div>
																	<RightArrows />
																</div>
															</div>
														);
													})}
											</div>
										);
									})}
							</div>
						</div>
					)}
				</div>
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.content {
		background: white;
		padding: 1em;
		z-index: 10;
		position: relative;

		.description {
			display: flex;
			justify-content: space-between;
			min-height: 354px;
			border-bottom: 4px solid #004885;

			.left {
				.inner-description {
					margin: 0 15px;
				}

				.customer-quote {
					color: white;
					right: 0;
					display: flex;
					justify-content: space-between;
					position: relative;
					right: -50px;

					.left {
						padding: 1.5rem;
						width: 66%;
						background: #004885;
						margin: 0 0 0 auto;
						.comments {
							font-size: 1.8rem;
						}
					}

					.svg {
						width: 67px;
						margin-top: -7px;
					}
				}

				@media (max-width: 998px) {
					.customer-quote {
						display: none;
					}
				}
			}

			.right {
				min-width: 325px;
				position: relative;

				.image {
					top: -6rem;
					position: absolute;
					right: -2rem;
					width: 325px;
				}
			}

			@media (max-width: 998px) {
				.right {
					display: none;
				}
			}
		}

		@media (max-width: 998px) {
			.description {
				min-height: 0px;
			}
		}
	}

	.exterinor-content {
		background-color: #fff;

		.content {
			margin-top: 0;
			padding-top: 0;
		}

		.application {
			position: relative;
			min-height: 5rem;

			h2 {
				padding: 15px;
				position: absolute;
				bottom: 0;
				left: 0;
				background-color: #fff;
				margin-bottom: 0;
			}
		}

		.applications {
			display: flex;
			justify-content: left;
			flex-wrap: wrap;
			margin-bottom: 1rem;

			.item {
				padding: 10px;
			}
		}

		.tag-list {
			display: flex;
			justify-content: left;
			flex-wrap: wrap;
			margin: 0 -1rem;
			margin-bottom: 1rem;

			.tag {
				padding: 0.2rem 1rem;
				div {
					display: block;
					background-color: #004885;
					padding: 1rem;
					color: #fff;
					line-height: 1rem;
					height: 5rem;
				}
			}
		}

		.reference-list {
			display: flex;
			border: 1px solid #ccc;
			padding: 0.3rem;
			flex-wrap: wrap;
			margin-bottom: 1rem;

			.item {
				cursor: pointer;
			}
		}

		.products {
			display: flex;
			justify-content: left;
			flex-wrap: wrap;
			margin-bottom: 3rem;
			.item {
				padding: 0 5px;
				margin-bottom: 10px;
			}
		}

		.successStories {
			position: relative;

			.title {
				background-color: #fff;
				color: #004885;
				font-size: 2rem;
				position: absolute;
				left: 0;
				top: 0;
				padding: 1rem 2rem;
				font-weight: 600;
			}

			.list {
				position: absolute;
				top: 6rem;
				display: flex;
				justify-content: space-around;
				.item {
					background-color: #fff;
					padding: 1rem;

					.productLink {
						border: 1px solid #e9eae9;
						padding: 1rem;
						display: flex;
						justify-content: space-between;
						color: #004885;
						cursor: pointer;
						margin-top: 5px;

						b {
							color: #dd271d;
						}
					}
				}
			}
		}
	}
`;
